import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shared shell for /terms and /privacy — both are static content pages that
// only differ in which legalContent.js document they render.
export function useLegalConfig() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    axios.get(`${API}/legal/config`).then((res) => setCfg(res.data)).catch(() => setCfg({}));
  }, []);
  return cfg;
}

export function LegalPageShell({ testId, content, hideDraftDisclaimer }) {
  const { t } = useLanguage();
  if (!content) {
    return <div className="min-h-[50vh] flex items-center justify-center text-sm text-slate-400">{t("common.loading")}</div>;
  }
  return (
    <div data-testid={testId} className="min-h-screen bg-white px-4 sm:px-6 py-8 max-w-3xl mx-auto">
      <Link to="/" data-testid={`${testId}-back`} className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#028CF8] mb-6 transition-colors">
        <ArrowLeft className="h-4 w-4" /> {t("legal.backHome")}
      </Link>
      <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-1">{content.title}</h1>
      <p className="text-sm text-slate-400 mb-8">{content.updated}</p>
      <div className="space-y-6">
        {content.sections.map((s) => (
          <section key={s.h}>
            <h2 className="text-base font-semibold text-slate-900 mb-1.5">{s.h}</h2>
            <p className="text-sm text-slate-600 leading-relaxed">{s.p}</p>
          </section>
        ))}
      </div>
      {!hideDraftDisclaimer && (
        <p className="text-xs text-slate-400 mt-10 border-t border-slate-100 pt-4">{t("legal.draftDisclaimer")}</p>
      )}
    </div>
  );
}
